// src/js/main.js

import "../scss/main.scss";

// import { initFeaturable } from "./_featurable";
import General from "./_general";
import Header from "./_header";
import hero from "./_hero";
import lenis from "./_lenis";
import marquee from "./_marquee";
import mission from "./_mission";
import Observer from "./_observer";
// import { renderPageSpeedInsight } from "./_pageSpeedBadge";
import scrambleTexts from "./_scramble";

const App = {
	handleEvents() {
		window.addEventListener("resize", () => {
			this.general.checkOverflow();
		});
	},

	init() {
		this.general = new General();
		this.handleEvents();

		this.observer = new Observer();
		this.lenis = lenis;

		this.header = new Header();
		this.header.init();

		// initFeaturable();

		// renderPageSpeedInsight();

		marquee.init();

		scrambleTexts.init();

		hero.init();
		mission.init();
	},
};

document.addEventListener("DOMContentLoaded", () => {
	App.init();

	// Save original title
	const originalTitle = document.title;

	// Custom message when tab is hidden
	const hiddenTitle = "🦄 Creiamo qualcosa di unico?";

	// Handle visibility change
	document.addEventListener("visibilitychange", () => {
		if (document.hidden) {
			document.title = hiddenTitle;
		} else {
			// Restore original title when user returns
			document.title = originalTitle;
		}
	});
});
